module.exports = __webpack_public_path__ + "static/media/instruction.838f4906.png";